import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=b6fd1242&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=js&"
export * from "./main-footer.vue?vue&type=script&lang=js&"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=b6fd1242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fd1242",
  null
  
)

export default component.exports